export function isPromise<T, S>(
  obj: PromiseLike<T> | S,
): obj is PromiseLike<T> {
  return (
    !!obj &&
    (typeof obj === "object" || typeof obj === "function") &&
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    typeof obj.then === "function"
  );
}
